export default __webpack_public_path__ + "static/media/ChrisArdington.a4902b88.jpg";